import { IAppState } from '../context/Context'
import { TCF } from '../../../../cmp/tcf/TCF'
import { bodyScroll } from '../../../helpers/scroll'
import { AC } from '../../../ac/AC'

export namespace Save {
  export const reducer = (prevState: IAppState): IAppState => {
    AC.setSome(prevState.acceptedAcPartners)
    TCF.consentDoesApply({ displayUi: false })
    TCF.setCookie()
    // We're closing the modal, allow the body to scroll
    bodyScroll(true)

    return {
      ...prevState,
      view: null
    }
  }
}
